import React from 'react';
import DAGVisualizer from '../components/DAGVisualizer';

function Visualizer() {
  return (
    <div>
      <h1> </h1>
      {/* Your nodes content here */}
      <DAGVisualizer/>
    </div>
  );
}

export default Visualizer;
